export class SocketConstants {
    public static DOCTOR = 0;
    public static CONSUMER = 1;
    public static DIGI_MANAGER = 2;
}